import metadata from 'libphonenumber-js/metadata.full.json';
import parsePhoneNumber from 'libphonenumber-js';
import {removeFirstCharacter} from "@/common/utils/utils";

const countryCodeStrings = Object.keys(metadata.countries);
const callingCodeMap = new Map();
countryCodeStrings.forEach((cCode) => {
    callingCodeMap.set(metadata.countries[cCode][0], cCode);
});

export const getCountryFromCallingCode = (callingCode) => {
    if (callingCode === "1") {
        return "US";
    }
    return callingCodeMap.get(callingCode);
};

export const formatPhoneNumberForDisplay = (countryCode, phoneNum) => {
    if (!countryCode || !phoneNum) {
        return '';
    }

    const cCode = countryCode.charAt(0) === "0" ? removeFirstCharacter(countryCode) : countryCode;

    const phoneNumber = parsePhoneNumber(`+${cCode} ${phoneNum}`);

    if (!phoneNumber) {
        return "";
    }

    // Format in international format, e.g. "+1 202 555 0123"
    const formatted = phoneNumber.formatInternational();

    // Keep the first space, replace others with "-"
    const parts = formatted.split(' ');
    if (parts.length <= 2) return formatted; // nothing to replace

    const firstPart = parts[0];
    const rest = parts.slice(1).join('-');

    return `${firstPart} ${rest}`;
};
